import { getDifferenceBetweenFirstAndLastValues, getFirstAndLastValues, getsumOfValues } from "@/utils/analytics/growthMetricsUtils"

export const linkedinFollowersGrowthConfig = [
    {
        plotName: "followers",
        metricName: "followers",
        sumMetrics: false,
        title: "analytics_growth.followers",
        helpText: "analytics_growth.total_number_of_followers_across_platforms",
        cssIcon: "fa-duotone fa-solid fa-users",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getFirstAndLastValues,
    },
    {
        plotName: "followers",
        metricName: "followers",
        sumMetrics: false,
        title: "analytics_growth.new_followers",
        helpText: "analytics_growth.users_who_followed_you_recently",
        cssIcon: "fa-duotone fa-solid fa-user-plus",
        cssIconColor: "#7239EA",
        showGrowthBadge: false,
        calculateFunction: getDifferenceBetweenFirstAndLastValues,
    },
]

export const linkedinPlatformsGrowthConfig = [


    {
        plotName: "impressions",
        metricName: "impressions",
        sumMetrics: false,
        title: "analytics_growth.impressions",
        helpText: "analytics_growth.total_number_of_impressions_across_platforms",
        cssIcon: "fa-duotone fa-solid fa-eye",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "page_views",
        metricName: "page_views",
        sumMetrics: false,
        title: "analytics_growth.page_views",
        helpText: "analytics_growth.total_number_of_page_views_across_platforms",
        cssIcon: "fa-duotone fa-solid fa-eye",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    }
]
